var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, observe, action } from "mobx";
import * as SParsers from "./SportParsers";
import { ScoreboardType } from "../Constants";
export class Parser {
    constructor(retriever) {
        this.retriever = retriever;
        this.scoreboardType = ScoreboardType.Baseball; // change to be received from the BE once more scoreboards are implemented
        this.scoreboardData = {};
        this.backgroundImg = retriever.backgroundImg;
        this.disposeScoreboardData = () => { };
    }
    activate() {
        this.disposeScoreboardData = observe(this.retriever, "liveMasterEvent", change => {
            this.setScoreboardData(this.parseToModel(change.newValue));
        });
        this.retriever.activate();
    }
    deactivate() {
        this.retriever.deactivate();
        this.disposeScoreboardData();
    }
    setScoreboardData(data) {
        this.scoreboardData = data;
    }
    parseToModel(event) {
        let result = {};
        if (event === undefined || event.BaseballScoreBoardInfo === undefined) {
            return result;
        }
        if (typeof SParsers[this.scoreboardType] === "function") {
            result = SParsers[this.scoreboardType](event);
        }
        return result;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "scoreboardData", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "setScoreboardData", null);
//# sourceMappingURL=Parser.js.map